import { Checkbox, TableCell, TableRow } from "@mui/material";
import moment from "moment";
import React, { useState } from "react";
import { truncateString } from "../../../../../constants";

const TableRowSection = ({
  isItemSelected,
  row,
  numberType,
  handleClickRow,
  labelId,
  handleNavigateToDetails,
  userDetailsPageReports,
  hideCheckbox = false,
  columnWidths,
}) => {
  // const [showTableActionDropDown, setShowTableActionDropDown] = useState(false);
  return (
    <TableRow
      hover
      // onClick={(event) => handleClickRow(event, row.id)}
      role="checkbox"
      aria-checked={isItemSelected}
      tabIndex={-1}
      key={row.id}
      selected={isItemSelected}
      sx={{
        cursor: "pointer",
        height: 30,
        background: numberType === true ? "#F2F2F2" : "#fff",
      }}
    >
      {(userDetailsPageReports || hideCheckbox) ? undefined : (
        <TableCell
          padding="checkbox"
          style={{ background: "#fff" }}
          onClick={(event) => handleClickRow(event, row.id)}
        >
          <Checkbox
            color="primary"
            checked={isItemSelected}
            inputProps={{
              "aria-labelledby": labelId,
            }}
          />
        </TableCell>
      )}
      <TableCell
        // component="th"
        id={labelId}
        align="left"
        // scope="row"
        padding="none"
        onClick={handleNavigateToDetails}
        style={{
          ...tableTitleFieldStyles,
          width: columnWidths?.id || 200,
          minWidth: columnWidths?.id || 200,
          maxWidth: columnWidths?.id || 200,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
         title={row?.id}
      >
        {row?.id}
      </TableCell>
      <TableCell
        align="left"
        padding="none"
        style={{
          border: "1px solid #BABABA",
          fontFamily: "Avenir Book, sans-serif",
          paddingLeft: 10,
          width: columnWidths?.createdAt || 170,
          minWidth: columnWidths?.createdAt || 170,
          maxWidth: columnWidths?.createdAt || 170,
        }}
      >
        {row?.createdAt &&
          moment.unix(row?.createdAt?.seconds).format("MM-DD-YYYY HH:mm:ss")}
      </TableCell>
      <TableCell
        align="left"
        padding="none"
        style={{
          border: "1px solid #BABABA",
          fontFamily: "Avenir Book, sans-serif",
          textTransform: "capitalize",
          paddingLeft: 10,
          width: columnWidths?.["status.status"] || 170,
          minWidth: columnWidths?.["status.status"] || 170,
          maxWidth: columnWidths?.["status.status"] || 170,
        }}
      >
        {row?.status?.status}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.["status.action"] || 170,
          minWidth: columnWidths?.["status.action"] || 170,
          maxWidth: columnWidths?.["status.action"] || 170,
        }}
      >
        {row?.status?.action && truncateString(row?.status?.action, 20)}
      </TableCell>
      <TableCell
        align="left"
        padding="none"
        style={{
          border: "1px solid #BABABA",
          fontFamily: "Avenir Book, sans-serif",
          paddingLeft: 10,
          width: columnWidths?.["reportedByData.userName"] || 200,
          minWidth: columnWidths?.["reportedByData.userName"] || 200,
          maxWidth: columnWidths?.["reportedByData.userName"] || 200,
        }}
      >
        {row?.reportedByData?.userName}
      </TableCell>
      <TableCell
        align="left"
        padding="none"
        style={{ 
          ...tableCellStyles, 
          textTransform: "capitalize",
          width: columnWidths?.type || 170,
          minWidth: columnWidths?.type || 170,
          maxWidth: columnWidths?.type || 170,
        }}
      >
        {row?.type}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.reason || 170,
          minWidth: columnWidths?.reason || 170,
          maxWidth: columnWidths?.reason || 170,
        }}
      >
        {truncateString(row?.reason, 15)}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.title || 170,
          minWidth: columnWidths?.title || 170,
          maxWidth: columnWidths?.title || 170,
        }}
      >
        {truncateString(row?.title, 15)}
      </TableCell>
      <TableCell 
        padding="none" 
        align="left" 
        style={{
          ...tableCellStyles,
          width: columnWidths?.reportedItemId || 200,
          minWidth: columnWidths?.reportedItemId || 200,
          maxWidth: columnWidths?.reportedItemId || 200,
        }}
      >
        {truncateString(row?.reportedItemId, 15)}
      </TableCell>
      {/*
      <TableCell align="left" style={tableCellStyles}>
        {row.reactionId}
      </TableCell>
      */}
    </TableRow>
  );
};

export default TableRowSection;

const tableTitleFieldStyles = {
  // fontWeight: 600,
  border: "1px solid #BABABA",
  color: "#00A7CD",
  fontFamily: "Avenir Book, sans-serif",
  paddingLeft: 10,
  height: 30,
};

const tableCellStyles = {
  border: "1px solid #BABABA",
  cursor: "default",
  fontFamily: "Avenir Book, sans-serif",
  paddingLeft: 10,
  height: 30,
};
// const tableStatusCellStyles = {
//   border: "1px solid #BABABA",
//   cursor: "pointer",
//   fontWeight: 600,
// };
